// Master JS for Site V3 header

import { UserAvatar } from "./webcomponents/user-avatar.js";

// Register required webcomponents
UserAvatar.Register();

window.addEventListener("avatarUrlChange", e => {
    const menuAvatar = document.getElementById("headerMenuAvatar");
    if (menuAvatar) {
        menuAvatar.avatar = e.detail.content;
    }
});
